import { Formik } from "formik";
import { useEffect, useState } from "react";
import Spin from "../../../components/Spin";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
import { Input } from "../../../components/ui/input";
import { API, fileUpload, get } from "../../../config";
import { Button } from "../../../components/ui/button";
import { AddAdminStateSchema } from "../../../lib/Validation";

const AddEditState = ({ id, toggleShowAddEditState, edit, fetchStateData }) => {
  const [stateData, setStateData] = useState([]);
  const [loading, setLoading] = useState(false);

  async function fetchData() {
    try {
      setLoading(true);
      const reponse = await get(`${API.GET_ADMIN_STATE_LIST}/` + id);
      setStateData(reponse?.data?.data);
      setLoading(false);
    } catch (e) {
      setStateData(null);
    }
  }

  useEffect(() => {
    if (edit) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    formData.append("name", value?.name ? value?.name : "");
    formData.append("short_name", value?.short_name ? value?.short_name : "");

    if (edit) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.GET_ADMIN_STATE_LIST}${edit ? `/${id}` : ""}`,
        formData
      );
      setLoading(false);
      if (data) {
        toggleShowAddEditState();
        fetchStateData();
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={{
        name: stateData?.name,
        short_name: stateData?.short_name ? stateData?.short_name : "",
      }}
      enableReinitialize={true}
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddAdminStateSchema}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
      }) => (
        <>
          {loading && <Spin fullscreen={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box overflow-y-auto overflow-x-hidden max-h-[80vh] p-4 border rounded-lg grid gap-4">
              <div className="grid gap-4">
                <div className="grid gap-2 col-span-2">
                  <Label htmlFor="name">
                    <CustomLabelText
                      required={true}
                      labelText="Name"
                      errorField={errors?.name}
                    />
                  </Label>
                  <Input
                    id="name"
                    type="text"
                    name="name"
                    value={values?.name ? values?.name : ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    onKeyPress={(e) => {
                      e.which === 13 && e.preventDefault();
                    }}
                    className={
                      errors?.name &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                  />
                </div>
                <div className="grid gap-2 col-span-2">
                  <Label htmlFor="name">
                    <CustomLabelText
                      required={true}
                      labelText="Short Name"
                      errorField={errors?.short_name}
                    />
                  </Label>
                  <Input
                    id="short_name"
                    type="text"
                    name="short_name"
                    value={values?.short_name ? values?.short_name : ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    onKeyPress={(e) => {
                      e.which === 13 && e.preventDefault();
                    }}
                    className={
                      errors?.short_name &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditState();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditState;
